import { Routes, Route, Navigate } from "react-router-dom";

import IntianaTravelTours from "./IntianaTravelTours";

const intianaTravelToursRoutes = [
     {routeName: 'umrah-packages' , component: <IntianaTravelTours/>},
     {routeName: 'Business-travel' , component: <IntianaTravelTours/>},
     {routeName: 'leisure-travel' , component: <IntianaTravelTours/>},
     {routeName: 'domestic-int-tours' , component: <IntianaTravelTours/>},
     {routeName: 'air-ticketing' , component: <IntianaTravelTours/>},
    
     

];

const IntianaTravelToursRoutes = () => {
    return (
    <Routes>
       {intianaTravelToursRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default IntianaTravelToursRoutes;